import logger from "../utils/logger";
export const loadOwnershipTransfers = async (request, token, setOwnershipTransfers) => {
  if (!token) return;
  const data = await request('/api/v1/ownership-transfers/?status=pending', {});
  setOwnershipTransfers(data || []);
};
export const loadTransferScopeMembers = async (request, accountId, setTransferScopeLoading, setTransferScopeMembers) => {
  if (!accountId) return;
  setTransferScopeLoading(true);
  try {
    const data = await request(`/api/v1/access/marketplaces/${accountId}/memberships`, {});
    setTransferScopeMembers(data || []);
  } catch (error) {
    logger.error(error);
    setTransferScopeMembers([]);
  } finally {
    setTransferScopeLoading(false);
  }
};
export const loadMemberships = async (request, accountId, setMemberships) => {
  if (!accountId) return;
  const data = await request(`/api/v1/access/marketplaces/${accountId}/memberships`, {});
  setMemberships(data);
};
export const loadSentCabinetInvites = async (request, accountId, setSentCabinetInvites) => {
  if (!accountId) {
    setSentCabinetInvites([]);
    return;
  }
  try {
    const data = await request(`/api/v1/invitations/marketplaces/${accountId}`, { silent: true });
    setSentCabinetInvites(data || []);
  } catch (error) {
    const msg = String(error?.message || error);
    if (msg.includes('Not authenticated') || msg.includes('403')) {
      setSentCabinetInvites([]);
      return;
    }
    logger.error(error);
    setSentCabinetInvites([]);
  }
};
export const loadCabinetInvites = async (request, setCabinetInvites) => {
  try {
    const data = await request('/api/v1/invitations/me', { silent: true });
    setCabinetInvites(data || []);
  } catch (error) {
    const msg = String(error?.message || error);
    if (msg.includes('Not authenticated') || msg.includes('403')) {
      setCabinetInvites([]);
      return;
    }
    logger.error(error);
    setCabinetInvites([]);
  }
};
export const loadProjectInvites = async (request, setProjectInvites) => {
  try {
    const data = await request('/api/v1/workspaces/invites', { silent: true });
    setProjectInvites(data || []);
  } catch (error) {
    const msg = String(error?.message || error);
    if (msg.includes('Not authenticated') || msg.includes('403')) {
      setProjectInvites([]);
      return;
    }
    logger.error(error);
    setProjectInvites([]);
  }
};
